import { useState } from 'react';
import { useCloseRequest } from 'src/modules/shared/hooks/use-close-request';
import { CloseRequestContext } from 'src/modules/shared/contexts/close-request-context';
import { ChevronUpDownIcon } from '@heroicons/react/24/solid';
import {
  Menu,
  MenuHandler,
  MenuItem,
  MenuList,
} from '@material-tailwind/react';
import Button from 'src/modules/shared/components/atoms/buttons/button';

interface CallMenuProps {
  callingWithoutInternet: boolean;
  updateSetting: (value: boolean) => void;
  iconButtonClasses?: string;
}

const CallMenu = ({
  callingWithoutInternet,
  updateSetting,
  iconButtonClasses,
}: CallMenuProps) => {
  const [open, setOpen] = useState(false);
  const closeLayerId = useCloseRequest({
    isOpen: open,
    onClose: () => setOpen(false),
  });
  const handleMenuItemClick = (useInternet: boolean) => {
    if (callingWithoutInternet === useInternet) return;

    updateSetting(useInternet);
  };

  const selectedItemClasses = 'bg-call-500 hover:!bg-call-600 text-white';

  return (
    <CloseRequestContext.Provider value={closeLayerId}>
      <Menu open={open} handler={setOpen}>
        <MenuHandler>
          <Button
            size="xs"
            variant="call"
            appearance="filled"
            isIconOnly
            className={`w-7 rounded-none rounded-r-lg ${iconButtonClasses ?? ''}`}
          >
            <ChevronUpDownIcon className={'h-5 w-5 text-white'} />
          </Button>
        </MenuHandler>
        <MenuList className="p-2">
          <MenuItem
            onClick={() => handleMenuItemClick(false)}
            className={`flex items-center ${callingWithoutInternet ? '' : selectedItemClasses}`}
          >
            <span className={`${callingWithoutInternet ? '' : 'text-white'}`}>
              Llamar por internet
            </span>
          </MenuItem>
          <MenuItem
            onClick={() => handleMenuItemClick(true)}
            className={`flex items-center ${callingWithoutInternet ? selectedItemClasses : ''}`}
          >
            <span className={`${callingWithoutInternet ? 'text-white' : ''}`}>
              Llamar por teléfono
            </span>
          </MenuItem>
        </MenuList>
      </Menu>
    </CloseRequestContext.Provider>
  );
};

export default CallMenu;
